import { parseDateString as _parseDateString } from 'sletat-common-utils/lib/date/lib/parseDateString';


export function parseDateString(date: string): Date | null {
    return _parseDateString(date, 'DD.MM.YYYY');
}
